export default function (...data: Record<string, any>[]) {
  if (typeof window === 'undefined') {
    return
  }

  const criteoQueue: Array<any> = (window as any).criteo_q || []

  ;(window as any).criteo_q = criteoQueue

  criteoQueue.push(...data)
}
